import { lazy } from 'react'
import RequireAuthentication from '@/router/guards/RequireAuthentication'
import { Route } from 'react-router-dom'

const FAQ = lazy(() => import('@/modules/StaticPages/pages/FAQ'))
const PrivacyPolicy = lazy(
  () => import('@/modules/StaticPages/pages/PrivacyPolicy'),
)
const QuestionsRequestSolicitation = lazy(
  () => import('@/modules/StaticPages/pages/QuestionsRequestSolicitation'),
)
const PsychosocialMapping = lazy(
  () => import('@/modules/StaticPages/pages/PsychosocialMapping'),
)

const StaticPagesRoutes = [
  <RequireAuthentication
    path="/duvidas"
    key="/duvidas"
    exact
    component={FAQ}
  />,
  <Route
    path="/politicas-de-privacidade"
    key="/politicas-de-privacidade"
    exact
    component={PrivacyPolicy}
  />,
  <RequireAuthentication
    path="/duvidas/solicitar-consulta"
    key="/duvidas/solicitar-consulta"
    exact
    component={QuestionsRequestSolicitation}
  />,
  <RequireAuthentication
    path="/mapeamento-psicossocial"
    key="/mapeamento-psicossocial"
    exact
    component={PsychosocialMapping}
  />,
]

export default StaticPagesRoutes
